import React from "react";

import { Button, ButtonGroup, SkeletonBlock } from "@zapier/design-system";

import { useSize } from "@zapier/payment/esm/hooks/useSize";

type PaymentFormButtonProps = {
  /** Submit button text */
  buttonText?: string;
  /** Enable submit button */
  canSubmit?: boolean;
  /** Show cancel button */
  hasCancelButton?: boolean;
  /** Show busy indicator on submit button */
  isBusy?: boolean;
  /** On cancel */
  onCancel: () => void;
};

const PaymentFormButtons = (props: PaymentFormButtonProps) => {
  const size = useSize();
  return (
    <ButtonGroup
      columnSize={size === "small" ? "100%" : "minmax(100px, auto)"}
      justify="center"
    >
      {props.hasCancelButton && (
        <Button
          color="secondary"
          onClick={props.onCancel}
          type="button"
          size="small"
        >
          Cancel
        </Button>
      )}
      {props.isBusy ? (
        <SkeletonBlock height={50} width="100%" />
      ) : (
        <Button disabled={!props.canSubmit} type="submit" size="small">
          {props.buttonText}
        </Button>
      )}
    </ButtonGroup>
  );
};

PaymentFormButtons.defaultProps = {
  buttonText: "Save",
};
export default PaymentFormButtons;
